
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { timeUnits } from '@/common/utils/helpers';
import { useItemSettingList } from '@/modules/item/app/setting/model/list';
import { ROUTE_NAME_ITEM } from '@/modules/item/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_ITEM.APP_SETTING.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, canAddNewItem, fetchList, actions } = useItemSettingList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Option, label: 'Time Unit', key: 'timeUnit', options: timeUnits },
                { type: TableColumnType.Text, label: 'Time Duration', key: 'timeDuration' },
                { type: TableColumnType.DateTime, label: 'Start Time', key: 'startTime' },
                { type: TableColumnType.DateTime, label: 'Next Start Time', key: 'nextStartTime' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_ITEM.APP_SETTING.EDIT, params: { id: row.id } }
                    }),
                    canShow: (row: any) => row.canEdit
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { canAddNewItem, list, total, table, ROUTE_NAME_ITEM };
    }
});
